import {
  Chart as ChartJS,
  LinearScale,
  Tooltip,
  Legend,
  CategoryScale,
  PointElement,
  LineElement,
  Title
} from 'chart.js';
import {Line} from 'react-chartjs-2';
import {format/* , parse, addYears */} from 'date-fns';
import {LineFitter} from './LeastSqFit';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const font = {
  size: 15
};

const options = {
  responsive: true,
  scale: {
    y: {
      suggestedMin: 700,
      suggestedMax: 1000,
      beginAtZero: false
    }
  },
  scales: {
    x: {
      title: {
        display: true,
        text: 'Date',
        font
      }
    },
    y: {
      title: {
        display: true,
        text: 'Rating',
        font
      }
    }
  },
  plugins: {
    title: {
      display: true,
      text: 'Player Rating History',
      font: {
        size: 16
      }
    }
  }
};

const PALETTE = [
  '#36a2eb',
  '#ff6384',
  '#4bc0c0',
  '#ff9f40',
  '#96f',
  '#ffcd56',
  '#c9cbcf',
  //Mixes of the default Chart.js palette https://www.chartjs.org/docs/latest/general/colors.html#default-color-palette
  '#a2eb36',
  '#eb36a2',
  '#6384ff',
  '#84ff63',
  '#c0c04b',
  '#c04bc0',
  '#9f40ff',
  '#40ff9f',
  '#6f9',
  '#f96',
  '#cd56ff',
  '#56ffcd',
  '#cbcfc9',
  '#cfc9cb'
];

const DATE_FORMAT = 'dd/MM/yyyy';
const lineFitters = [];

const Chart = ({players}) => {
  console.log('players=', players);
  let paletteIdx = 0;
  const allDates = players
    .map((p) => p.ratingHistory.map((r) => new Date(r.date)))
    .flat()
    .sort((a, b) => a - b);
  const parsedDates = allDates.map((d) => format(d, DATE_FORMAT));
  const labels = [...new Set(parsedDates)];
  const data = {
    labels,
    datasets: players.map((p, i) => {
      const borderColor = PALETTE[paletteIdx % PALETTE.length];
      ++paletteIdx;
      const fitter = new LineFitter();
      fitter.addMultiWithDates(p.ratingHistory);
      lineFitters.push(fitter);
      return {
        label: p.name,
        data: p.ratingHistory.map((r) => ({
          y: r.rating,
          x: format(new Date(r.date), DATE_FORMAT)
        })),
        borderColor,
        backgroundColor: borderColor
        // trendlineLinear: {
        //   colorMin: borderColor,
        //   // colorMax: 'green',
        //   lineStyle: 'dotted',
        //   width: 2
        //   //projection: true
        // }
      };
    })
  };
  /* const predictions = [];
  data.datasets.forEach((ds, i) => {
    const ratings = ds.data.map((d) => d.y);
    const lastDate = parse(ds.data[0].x, DATE_FORMAT, new Date());
    const nextDate = addYears(lastDate, 1);
    const projection = lineFitters[i].project(nextDate);
    predictions.push({
      label: `${ds.label} forecast`,
      data: [
        {
          y: ratings[0],
          x: ds.data[0].x
        },
        {
          y: Math.round(projection),
          x: format(nextDate, DATE_FORMAT)
        }
      ],
      borderColor: ds.borderColor,
      borderDash: [0, 6],
      borderCapStyle: 'round',
      backgroundColor: 'rgba(255, 255, 255, 0)',
      fill: false
    });
  });
  data.datasets = data.datasets.concat(predictions); */
  return <Line options={options} data={data} />;
};

export default Chart;
